export default __webpack_public_path__ + "static/media/hidepanel_PC.3b9ff7da.svg";